

   export const translateBusinessType = (type) => {
    const typeMap = {
      PURCHASE_DEMAND: "采购信息",
      SUPPLY_OPPORTUNITY: "供应机会",
      COOPERATION_PROJECT: "合作项目",
      INVESTMENT_OPPORTUNITY: "投资机会",
      TECHNICAL_COOPERATION: "技术合作",
      OTHER: "其他",
    };
    return typeMap[type] || type || "未知类型";
  };